import { Container } from '@mui/material'
import React from 'react'

export const ContainerComponent = (props) => {
    return <Container style={{ maxWidth: '1800px', ...props.style }}>{props.children}</Container>
}
